import {Linking, Platform} from 'react-native';

/**
 * Opens provided link using predefined URL schemas.
 * @param {('tel'|'mail'|'url'|'mapLocation'|'update'|'sms')} type type of URL schema
 * @param {String} url
 */
export const openURL = (type: any, url: any) => {
  switch (type) {
    case 'tel':
      return Linking.openURL(`tel:${url}`);

    case 'mail':
      return Linking.openURL(`mailto:${url}`);

    case 'url':
      return Linking.openURL(`${url}`);

    case 'mapLocation':
      return Linking.openURL(
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        Platform.select({ios: `maps:?q=${url}`, android: `geo:?q=${url}`}),
      );

    case 'sms':
      return Linking.openURL(
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        Platform.select({
          ios: `sms:${url}&body=${''}`,
          android: `sms:${url}?body=${''}`,
        }),
      );

    case 'update':
      return Linking.openURL(
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        Platform.select({
          ios: 'itms-apps://itunes.apple.com/us/app/apple-store/id1518841061?mt=8',
          android:
            'https://play.google.com/store/apps/details?id=com.optaviaconnect',
        }),
      );

    default:
      return Promise.resolve();
  }
};

export const openURLInNewTabOnWeb = (url: string) => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
    return Promise.resolve();
  }

  return openURL('url', url);
};

export const canOpenURL = (url: any) => {
  return Linking.canOpenURL(url);
};
